(function () {
  if (getCookie("external_store_redirect") == "rejected") {
    return;
  }
  const externalStoreData = theme.shop.external_stores;
  externalStoreData &&
    window.geoip2 &&
    window.geoip2.country(async (location) => {
      const language = String(navigator.language).substring(0, 2).toLowerCase();
      const countryCode = location.country.iso_code;
      const countryName =
        location.country.names[language] || location.country.names["en"];
      if (externalStoreData?.[countryCode]) {
        const encodeData = window.decodeURIComponent(
          `${language},${countryCode},${countryName}`
        );

        const resText = await apiFetchText(
          `/pages/about/${encodeData}`,
          `?section_id=external-store-suggestion-modal`
        );

        const modal = document.createElement("div");
        modal.innerHTML = resText;
        document.body.appendChild(modal);
        const close_btn = document.getElementById("ModalClose-external-store");
        close_btn.addEventListener("click", () => {
          if (externalStoreData.frequency !== "always") {
            setCookie("external_store_redirect", "rejected", 1);
          }
        });
      }
    });
})();
